import React from "react";
import { TimedOverflowNotification } from "@ts-digital/arc/antd/TimedOverflowNotification";
import "@ts-digital/arc/index.css";

const ErrorNotification = ({
  hideToast,
  title,
  message,
  show,
  type,
  duration
}) => {
  return (
    show &&
				<TimedOverflowNotification
				// max ms value allowed (see at https://stackoverflow.com/questions/3468607/why-does-settimeout-break-for-large-millisecond-delay-values)
				  duration={/* 2147483647*/ duration}
				  onClose={hideToast}
				  title={title}
				  variant={type}
				>
				  {message}
				</TimedOverflowNotification>
  );
};

export default ErrorNotification;